import { statusLabels } from "@/constant/statusConstants";

const statusLabelMap = statusLabels();

export const BASE_IMPORT_DATA = {
    BLOG_POSTS: {
        dataName: "Blog Posts",
        shouldUniqueColumn: "Title",
        requiredColumns: [
            "Sport ID",
            "Sort Order",
            "Status",
            "Title",
            "Sub Title",
            "Content",
        ],
        columnOptions: {
            columnName: "Status",
            validValues: Object.values(statusLabelMap),
        }
    },
};

